// extracted by mini-css-extract-plugin
export default {"content":"AddDialog_content__rVDmy","select":"AddDialog_select__fFrMe"};